import React, { CSSProperties } from "react";

interface HystarDrylabImageProps {
    color?: string;
    style?: CSSProperties;
    svgWidth?: string;
    svgHeight?: string;
}
const HystarDrylabImage: React.FC<HystarDrylabImageProps> = (props: HystarDrylabImageProps) => {
    const {color} = props;
    return (
        <div style={props?.style}>
            <svg viewBox="0 0 128 128" width={props.svgWidth || "32"} height={props.svgHeight || "32"} className="images-icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px">
                <g>
                    <path fill={color ? color: '#ffffff'} d="M114.14,21.34c-6.99,1.01-13.97,3.15-20.52,5.84c-5.63,2.31-9.58,2.17-14.24-2.24
                        c-7.51-7.1-23.01-7.19-30.47-0.09c-4.85,4.61-8.91,4.45-14.69,2.21c-7.04-2.73-14.56-4.63-22.04-5.74
                        c-5.45-0.81-8.96,3.23-8.56,8.6c0.48,6.44,2.35,12.33,7.62,16.8c2.73,2.31,4.59,5.69,7.4,7.85c3.03,2.32,6.58,4.69,10.19,5.28
                        c2.44,0.4,6.7-1.57,7.75-3.68c1.18-2.37,0.53-6.53-0.83-9.12c-2.57-4.88-8.55-6.67-14.37-5.04c-4.51,1.26-7.7-0.96-9.8-4.14
                        c-1.36-2.05-2.09-7.12-1.36-7.5c2.82-1.46,6.45-2.44,9.56-2.02c4.19,0.57,8.11,2.94,12.28,3.94
                        c12.98,3.11,13.08,15.73,18.09,24.56c2.14,3.77,2.44,8.8,2.81,13.32c0.47,5.75,0.01,11.56,0.24,17.34
                        c0.19,4.63,0.81,9.25,1.25,13.88c-1.11,11.56-1.11,11.56,10.07,11.55c1.5,0,3.01-0.13,4.5,0.01c3.64,0.34,4.96-1.29,5.13-4.88
                        c0.43-9.28,1.22-18.55,1.75-27.83c0.14-2.48,0.21-5.07-0.33-7.46c-1.51-6.6-0.28-12.51,3.42-18.09c1.09-1.65,2.29-3.48,2.6-5.36
                        c1.71-10.48,8.82-15.62,18.09-18.47c4.56-1.4,9.31-2.61,14.03-2.89c4.25-0.25,5.8,2.61,4.65,6.74c-1.46,5.28-6.79,8.28-12.35,6.96
                        c-6.06-1.44-13,2.12-15.12,7.77c-1.52,4.04-0.09,8.04,3.49,9.81c5.03,2.47,12.12,0.01,15.75-5.26c1.48-2.14,3.14-4.31,5.16-5.89
                        c5.15-4.02,8.04-9.09,8.95-15.56C125.35,24.66,122.03,20.2,114.14,21.34z"/>
                    <path fill={color ? color: '#ffffff'}
                          d="M93.68,111.48c1.52,0.64,3.15,1.04,4.82,1.11c4.1,0.17,7.68-0.5,10.62-1.88l-7.69-7.34L93.68,111.48z"/>
                    <path fill={color ? color: '#ffffff'}
                          d="M85.24,87.9c-0.75,2.27-1.28,4.66-1.52,7.21c-0.16,1.73-0.01,3.44,0.39,5.08l6.68-6.99L85.24,87.9z"/>
                    <path fill={color ? color: '#ffffff'}
                          d="M100.79,65.62c-2.89,2.98-5.65,5.95-8.09,9.05l8.26,7.89l7.77-8.13C106.3,71.43,103.57,68.55,100.79,65.62z"
                    />
                    <path fill={color ? color: '#ffffff'}
                          d="M117.59,98.45c0.05-0.57,0.09-1.14,0.09-1.74c0.02-3.23-0.47-6.19-1.33-8.96l-4.75,4.97L117.59,98.45z"/>
                    <polygon fill={color ? color: '#ffffff'} points="119.44,78.73 114.57,74.08 101.08,88.21 86.96,74.72 82.32,79.58 96.44,93.07 82.95,107.19
			                87.81,111.84 101.3,97.71 115.42,111.21 120.07,106.34 105.94,92.85"/>
                </g>
            </svg>
        </div>
    );
};

export default HystarDrylabImage;
